import { render } from "./ManutencaoPage.vue?vue&type=template&id=3adcd1e0&scoped=true"
import script from "./ManutencaoPage.vue?vue&type=script&lang=js"
export * from "./ManutencaoPage.vue?vue&type=script&lang=js"

import "./ManutencaoPage.vue?vue&type=style&index=0&id=3adcd1e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adcd1e0"]])

export default __exports__